'use es6';

import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { isAppObjectTypeId } from 'customer-data-objects/crmObject/isAppObjectTypeId';
import makeObjectDefinitionsAdapter from './makeObjectDefinitionsAdapter';
const isAssetFamilySupported = assetFamily => assetFamily === DSAssetFamilies.APP_OBJECT_DEFINITION;
const includeObject = ({
  objectTypeId
}) => isAppObjectTypeId(objectTypeId);
export default makeObjectDefinitionsAdapter({
  isAssetFamilySupported,
  includeObject
});